<template>
  <section class="app-main" id="appMain">
    <div class="container is-fluid is-marginless app-content">
      <transition
        mode="out-in"
        enter-active-class="fadeIn"
        leave-active-class="fadeOut"
        appear>
        <router-view class="animated"></router-view>
      </transition>
    </div>
  </section>
</template>

<script>
  // import Update from '../notifications/update'
  // import Message from '../notifications/message'
  export default {
    components: {},
    mounted () {
      this.$http.get(this.$store.state.config.apiURL + '/version').then((response) => {
        if (this.$store.state.config.version === null) {
          this.$store.state.config.version = response.body
        }
      }, (response) => {
      })
      // this.$options.sockets['rebuild'] = (data) => {
      //   if (data.refresh) {
      //     let propsData = {
      //       context: this
      //     }
      //     Update.openUpdate(propsData)
      //   }
      // }
      // this.$options.sockets['message'] = (data) => {
      //   let propsData = {
      //     context: this,
      //     message: data.message
      //   }
      //   Message.openMessage(propsData)
      // }
    }
  }
</script>

<style lang="scss">
  @import '~bulma/sass/utilities/variables';
  @import '~bulma/sass/utilities/mixins';

  .app-main {
    padding-top: 50px;
    margin-left: 215px;
    transform: translate3d(0, 0, 0);
    @include mobile() {
      margin-left: 0;
    }
  }

  .app-content {
    padding: 20px;
  }
  h4 {
    color: #a1a1a1;
    border-bottom: #c3c3c3 1px solid;
    padding-bottom: 10px;
  }
  h4 strong {
    color: #363636;
  }
  .is-parent {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// AppMain.vue?223aa519